"use client";

import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
import { Card, CardContent } from "@/components/ui/card";
import { CircleCheck, Lightbulb } from "lucide-react";
export default function EquestrianPropertyDoorChallenges() {
  const {
    ref: headingRef,
    isVisible: headingVisible
  } = useRevealOnScroll();
  const {
    ref: contentRef,
    isVisible: contentVisible
  } = useRevealOnScroll();
  const {
    ref: tipsRef,
    isVisible: tipsVisible
  } = useRevealOnScroll();
  return <section data-section-id="257709" id="meaningful-work-with-real-impact" className="bg-slate-50 text-foreground py-16 md:py-24 border-b border-border/40">
      <div className="max-w-7xl mx-auto px-6 lg:px-8">
        <div className="grid grid-cols-1 lg:grid-cols-12 gap-10 lg:gap-16 items-start">
          <div ref={headingRef} className={`lg:col-span-5 transition-all duration-1000 ${headingVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-4"}`}>
            <div className="h-1 w-12 bg-secondary-500 mb-6 rounded-full" />

            <h2 className="font-default text-3xl md:text-4xl lg:text-5xl font-bold text-primary-600 leading-tight tracking-tight">
              Meaningful work with real impact.
            </h2>

            <p className="mt-5 font-default text-lg text-muted-foreground leading-relaxed">
              RiverBend’s work is practical, people-focused, and connected to
              real needs. Our team supports First Nation communities, Northern
              organizations, businesses, and partnerships with the systems,
              reporting, and planning needed to move important work forward.
            </p>
          </div>

          <div ref={contentRef} className={`lg:col-span-7 transition-all duration-1000 ${contentVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-4"}`}>
            <div className="rounded-3xl border border-border/70 bg-white p-6 md:p-8 shadow-sm">
              <div className="space-y-6">
                <div className="flex gap-4">
                  <div className="bg-secondary-100 rounded-xl p-2 shrink-0 h-fit">
                    <CircleCheck className="size-5 text-secondary-700 stroke-[3]" />
                  </div>

                  <div>
                    <h3 className="font-default text-lg font-semibold text-primary-600 mb-2">
                      Support that strengthens organizations
                    </h3>

                    <p className="font-default text-base text-muted-foreground leading-relaxed">
                      Your work at RiverBend can help clients improve financial
                      management, understand their funding, prepare for audits,
                      organize information, and make better decisions with
                      confidence.
                    </p>
                  </div>
                </div>

                <div className="flex gap-4">
                  <div className="bg-secondary-100 rounded-xl p-2 shrink-0 h-fit">
                    <CircleCheck className="size-5 text-secondary-700 stroke-[3]" />
                  </div>

                  <div>
                    <h3 className="font-default text-lg font-semibold text-primary-600 mb-2">
                      Practical tools, not just reports
                    </h3>

                    <p className="font-default text-base text-muted-foreground leading-relaxed">
                      You may contribute to reporting systems, Excel tools,
                      Power BI dashboards, funding schedules, project tracking
                      methods, and client-facing processes that make daily work
                      clearer and easier to manage.
                    </p>
                  </div>
                </div>

                <div className="flex gap-4">
                  <div className="bg-secondary-100 rounded-xl p-2 shrink-0 h-fit">
                    <CircleCheck className="size-5 text-secondary-700 stroke-[3]" />
                  </div>

                  <div>
                    <h3 className="font-default text-lg font-semibold text-primary-600 mb-2">
                      Work connected to long-term capacity
                    </h3>

                    <p className="font-default text-base text-muted-foreground leading-relaxed">
                      The goal is not only to complete a file or prepare a
                      report. The goal is to leave clients with stronger
                      systems, better information, and more confidence in how
                      their work is managed.
                    </p>
                  </div>
                </div>
              </div>

              <div ref={tipsRef} className={`mt-8 transition-all duration-1000 ${tipsVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-4"}`}>
                <Card className="border border-secondary-200 bg-secondary-50 shadow-none rounded-2xl">
                  <CardContent className="p-6">
                    <div className="flex gap-4">
                      <div className="flex-shrink-0 bg-white rounded-xl p-2 h-fit border border-secondary-100">
                        <Lightbulb className="size-5 text-secondary-700" />
                      </div>

                      <div>
                        <h3 className="font-default font-semibold text-primary-600 mb-2">
                          Our Mission
                        </h3>

                        <p className="font-default text-sm md:text-base text-muted-foreground leading-relaxed">
                          We help organizations build stronger financial and
                          management systems so they can focus on serving their
                          people, managing important projects, and planning for
                          the future.
                        </p>
                      </div>
                    </div>
                  </CardContent>
                </Card>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>;
}